import type { Company } from "@prisma/client";
import isCompanyVerified from "~/company/helpers/isCompanyVerified";
import UNVERIFIED_WARNINGS from "../../constants/companyVerification/UNVERIFIED_WARNINGS";

type UnverifiedWarningProps = {
  warningKey: keyof typeof UNVERIFIED_WARNINGS;
  company: Pick<Company, "verificationStatus">;
};

export default function UnverifiedWarning({
  company,
  warningKey,
}: UnverifiedWarningProps) {
  if (isCompanyVerified(company)) {
    return null;
  }

  return <>{UNVERIFIED_WARNINGS[warningKey]}</>;
}
